import type { Cin7PurchaseSummary } from "@/api/dtos";
import type { PurchaseSummary } from "@/api/purchase/_models/Purchase";

export const toPurchaseSummaryFromCin7PurchaseSummary = (
  dto: Cin7PurchaseSummary,
): PurchaseSummary => {
  return {
    id: dto.ID,
    blindReceipt: dto.BlindReceipt,
    orderNumber: dto.OrderNumber,
    status: dto.Status,
    orderDate: dto.OrderDate,
    invoiceDate: dto.InvoiceDate,
    supplier: dto.Supplier,
    supplierId: dto.SupplierID,
    invoiceNumber: dto.InvoiceNumber,
    invoiceAmount: dto.InvoiceAmount,
    paidAmount: dto.PaidAmount,
    invoiceDueDate: dto.InvoiceDueDate,
    requiredBy: dto.RequiredBy,
    baseCurrency: dto.BaseCurrency,
    supplierCurrency: dto.SupplierCurrency,
    creditNoteNumber: dto.CreditNoteNumber,
    orderStatus: dto.OrderStatus,
    stockReceivedStatus: dto.StockReceivedStatus,
    unstockStatus: dto.UnstockStatus,
    invoiceStatus: dto.InvoiceStatus,
    creditNoteStatus: dto.CreditNoteStatus,
    lastUpdatedDate: dto.LastUpdatedDate,
    combinedReceivingStatus: dto.CombinedReceivingStatus,
    combinedInvoiceStatus: dto.CombinedInvoiceStatus,
    combinedPaymentStatus: dto.CombinedPaymentStatus,
    type: dto.Type,
    isServiceOnly: dto.IsServiceOnly,
    dropShipTaskId: dto.DropShipTaskID,
  };
};
